import { useEffect } from 'react';

import { useParticipateCampaignsMutation } from 'src/hooks/useCampaignQuery';
import useLogin from 'src/hooks/useLogin';

const useParticipateCampaigns = () => {
  const { isLogin } = useLogin();
  const { mutate: participateCampaigns } = useParticipateCampaignsMutation();

  useEffect(() => {
    if (isLogin) {
      participateCampaigns();
    }
  }, [isLogin, participateCampaigns]);
};

export default useParticipateCampaigns;
